module.exports = __webpack_public_path__ + "img/right.982224e9.svg";